"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ConfirmSingleReportModal = _interopRequireDefault(require("./ConfirmSingleReportModal"));
var _modalDecorator = _interopRequireDefault(require("../../../hocs/modalDecorator"));
var _modalActions = require("../../../redux/actions/modalActions");
var _reportActions = require("../../../redux/actions/reportActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = {
  generateReport: _reportActions.generateReport
};
var container = (0, _reactRedux.connect)(null, mapDispatchToProps)(_ConfirmSingleReportModal["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.CONFIRM_SINGLE_REPORT
})(container);